import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TransactionAuthorizationResult } from '@zero/shared/util-models';
import { cryptoOnboardingActions, cryptoOnboardingFeature } from '../+state';

@Injectable({ providedIn: 'root' })
export class CryptoOnboardingFacade {
  readonly #store = inject(Store);

  public readonly status$ = this.#store.select(cryptoOnboardingFeature.selectStatus);
  public readonly customerAddress$ = this.#store.select(cryptoOnboardingFeature.selectCustomerAddress);
  public readonly addressConfirmed$ = this.#store.select(cryptoOnboardingFeature.selectAddressConfirmed);
  public readonly dataToAuthorize$ = this.#store.select(cryptoOnboardingFeature.selectDataToAuthorize);
  public readonly loading$ = this.#store.select(cryptoOnboardingFeature.selectLoading);
  public readonly authenticationFinished$ = this.#store.select(cryptoOnboardingFeature.selectAuthenticationFinished);
  public readonly error$ = this.#store.select(cryptoOnboardingFeature.selectError);

  public loadOnboardingStatus() {
    this.#store.dispatch(cryptoOnboardingActions.loadStatus());
  }

  public acceptConditions() {
    this.#store.dispatch(cryptoOnboardingActions.acceptConditions());
  }

  public loadCustomerAddress() {
    this.#store.dispatch(cryptoOnboardingActions.loadCustomerAddress());
  }

  public confirmAddress() {
    this.#store.dispatch(cryptoOnboardingActions.confirmAddress());
  }

  public resetAddressConfirmationDate() {
    this.#store.dispatch(cryptoOnboardingActions.resetAddressConfirmationDate());
  }

  public acceptContract() {
    this.#store.dispatch(cryptoOnboardingActions.acceptContract());
  }

  public handleAuthenticationResult(result: TransactionAuthorizationResult) {
    this.#store.dispatch(cryptoOnboardingActions.handleAuthenticationResult({ result }));
  }
}
